var { Admin } = require("src/client-ts/containers/Admin/");

exports.newTypescriptAdmin = Admin;
